module.exports = __webpack_public_path__ + "static/media/icon_exit.2a67e79f.svg";